import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import 'moment/locale/de';
import config from '../../../config/config.js';
import axios from 'axios';
import Select2 from 'react-select2-wrapper';
import swal from 'sweetalert';
import SSPState from '../../elements/SSPState';
import SSPGotFoodStamp from '../../elements/SSPGotFoodStamp';
import SSPStewardNumber from '../../elements/SSPStewardNumber';
import ChangeShift from '../../elements/ChangeShift';
import ChangeShiftVertical from '../../elements/ChangeShiftVertical';
import EventBus from '../../../helpers/EventBus';

class SupporterShiftsBlock extends Component {

    constructor(props) {
        super(props);

        this.state = {
            shifts: [],

            availableShifts: [],
            adding: false,
            shiftToAdd: null,
            addingLoading: false,
            notFound: false,
            lockedShiftStatusChangeId: null,
        };

        this.loadShifts = this.loadShifts.bind(this);
        this.loadAvailableShifts = this.loadAvailableShifts.bind(this);
        this.startAddShift = this.startAddShift.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCancelAddShift = this.handleCancelAddShift.bind(this);
        this.handleAddShift = this.handleAddShift.bind(this);
        this.handleDeleteShift = this.handleDeleteShift.bind(this);
        this.handleShiftStatusChanges = this.handleShiftStatusChanges.bind(this);
    }

    componentDidMount() {
        this.loadShifts();
        EventBus.on('SupporterShiftsBlock-load', this.loadShifts);
    }

    componentWillUnmount() {
        EventBus.remove('SupporterShiftsBlock-load', this.loadShifts);
    }

    loadShifts() {
        let that = this;
        axios(config.server.endpoint + 'backend/supporter/shifts/' + this.props.supporterId, {
            method: 'get'
        }).then((response) => {
            if (response.status === 404) {
                that.setState({
                    notFound: true
                });
            }
            else if (response.status === 200) {
                that.setState({
                    shifts: response.data
                })
            }
        });
    }

    loadAvailableShifts() {
        this.setState({
            addingLoading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/supporter/shifts/available/' + this.props.supporterId, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    availableShifts: response.data,
                    addingLoading: false
                })
            }
        });
    }

    startAddShift() {
        this.loadAvailableShifts();
        this.setState({
            adding: true,
            shiftToAdd: null
        });
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleCancelAddShift() {
        this.setState({
            adding: false,
            shiftToAdd: null,
            addingLoading: false
        });
    }

    handleAddShift(e) {
        e.preventDefault();
        this.setState({
            addingLoading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/supporter/shift/' + this.props.supporterId, {
            method: 'post',
            data: {
                shift: this.state.shiftToAdd
            }
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    addingLoading: false
                });
                if (response.data.success === true) {
                    that.setState({
                        adding: false,
                        shiftToAdd: null
                    });
                    this.loadShifts();
                } else {
                    that.setState({
                        errors: {
                            shiftToAdd: response.data.errors.shift
                        }
                    });
                }
            }
        });
    }

    handleDeleteShift(shiftId) {
        const {t} = this.props;

        swal({
            title: t('supporter.supporterShifts.delete.really.title'),
            text: t('supporter.supporterShifts.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/supporter/shift/' + this.props.supporterId + '/' + shiftId, {
                    method: 'delete'
                }).then((response) => {
                    this.loadShifts();
                })
            }
        })
    }

    handleShiftStatusChanges(shiftId) {
        this.setState({
            lockedShiftStatusChangeId: shiftId
        });
        setTimeout(() => {
            this.setState({
                lockedShiftStatusChangeId: null
            })
        }, 3000)
    }


    render() {
        const {t} = this.props;
        return (
            <div className="ibox SupporterShiftsBlock">
                <div className="ibox-title">
                    <h5>{t('supporterScreen.supporterShifts.title')}</h5>
                    {!this.state.notFound ? (
                        <div className="ibox-tools">
                            <a onClick={this.startAddShift}>
                                <i className="fa fa-plus fa-1-5x"/>
                            </a>
                        </div>
                    ) : null}
                </div>
                <div className="ibox-content">
                    {!this.state.notFound ? (
                        <div>
                            {this.state.adding ? (
                                <form onSubmit={this.handleAddShift} className="m-b">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div
                                                className={"form-group" + ((this.state.errors && this.state.errors.shiftToAdd) ? ' has-error' : '')}>
                                                <label>{t('supporterShifts.shift.label')}</label>
                                                <Select2 data={this.state.availableShifts.map((el) => {
                                                    return {
                                                        text: (moment(el.startAt).format("dd, DD.MM., HH:mm") + " - " + moment(el.endAt).format("HH:mm") + ": " + el.locationName + (el.name !== el.locationGroupName ? ' (' + el.locationGroupName + ')' : '') + " (" + el.supporterAmount + "/" + el.slots + ")"),
                                                        id: el.id
                                                    }
                                                })} value={this.state.shiftToAdd} onChange={this.handleInputChange}
                                                         name="shiftToAdd"
                                                         disabled={this.state.addingLoading}
                                                         options={{placeholder: t('supporterShifts.shift.placeholder')}}
                                                         className="width-100p block"/>

                                                {(this.state.errors && this.state.errors.shiftToAdd) ? (
                                                    <span className="help-block">
                                                            {t('supporterShifts.shift.error.' + this.state.errors.shiftToAdd)}
                                                        </span>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 text-right">
                                            <button type="button" onClick={this.handleCancelAddShift}
                                                    className="btn btn-default" disabled={this.state.addingLoading}>
                                                {t('default.cancel')}
                                            </button>
                                            <button type="submit" className="btn btn-primary"
                                                    disabled={this.state.addingLoading}>
                                                {t('default.save')}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            ) : null}
                            <table className="table">
                                <tbody>
                                {this.state.shifts.map((shift) => (
                                    <tr>
                                        <td className={!shift.active ? "text-muted" : null}>
                                            <div>
                                                <span className="pull-right">
                                                    {shift.state.name}
                                                </span>
                                                <a onClick={() => {
                                                    this.props.openShiftDetailsDialog(shift.shift.id)
                                                }} className={!shift.active ? "text-muted" : null}>
                                                    <b>{moment(shift.shift.startAt).format("dd, DD.MM., HH:mm")} - {moment(shift.shift.endAt).format("HH:mm")}</b>
                                                    &nbsp;({moment(shift.shift.startAt).subtract(30, 'minutes').format("HH:mm")} - {moment(shift.shift.endAt).add(30, 'minutes').format("HH:mm")})
                                                </a>
                                            </div>
                                            <div>
                                                {shift.active ? (
                                                    <Fragment>
                                                        <div className="pull-right btn-group btn-group-xs">
                                                            <button type="button" onClick={() => this.handleDeleteShift(shift.shift.id)}
                                                                    className="btn btn-danger">
                                                                <i className="fa fa-trash"/>
                                                            </button>
                                                        </div>
                                                        <div className="pull-right btn-group btn-group-xs">
                                                            {shift.state.name === 'ASSIGNED' ? (
                                                              <SSPState style="primary" icon="check" id={shift.id}
                                                                        newState="CONFIRMED" disabled={this.state.lockedShiftStatusChangeId === shift.id}
                                                                        handleSaveStart={this.handleShiftStatusChanges}
                                                                        handleSaveSuccess={this.loadShifts}/>
                                                            ) : null}
                                                            {shift.state.name === 'CONFIRMED' ? (
                                                              <SSPState style="primary" icon="arrow-right" id={shift.id}
                                                                        newState="CHECKED_IN" disabled={this.state.lockedShiftStatusChangeId === shift.id}
                                                                        handleSaveStart={this.handleShiftStatusChanges}
                                                                        handleSaveSuccess={this.loadShifts}/>
                                                            ) : null}
                                                            {shift.state.name === 'CHECKED_IN' ? (
                                                              <SSPState style="primary" icon="check" id={shift.id}
                                                                        newState="CHECKED_OUT" disabled={this.state.lockedShiftStatusChangeId === shift.id}
                                                                        handleSaveStart={this.handleShiftStatusChanges}
                                                                        handleSaveSuccess={this.loadShifts}/>
                                                            ) : null}
                                                            {shift.state.name === 'CHECKED_IN' ? (
                                                              <SSPState style="warning" icon="times" id={shift.id}
                                                                        newState="CANCELLED" disabled={this.state.lockedShiftStatusChangeId === shift.id}
                                                                        handleSaveStart={this.handleShiftStatusChanges}
                                                                        handleSaveSuccess={this.loadShifts}/>
                                                            ) : null}
                                                        </div>
                                                        <div className="pull-right btn-group btn-group-xs">
                                                            <SSPGotFoodStamp id={shift.id} handleSaveSuccess={this.loadShifts}
                                                                             checked={shift.shift.gotFoodStamp}/>
                                                        </div>
                                                        {(shift.shift.onlyStewards || (shift.shift.location && shift.shift.location.stewardsNeeded)) ? (
                                                            <div className="pull-right btn-group btn-group-xs">
                                                                <SSPStewardNumber id={shift.id} handleSaveSuccess={this.loadShifts}
                                                                                  stewardNumber={shift.stewardNumber}/>
                                                            </div>
                                                        ) : null}
                                                        {['ASSIGNED', 'CONFIRMED'].includes(shift.state.name) ? (
                                                          <div className="pull-right btn-group btn-group-xs">
                                                              <ChangeShiftVertical id={shift.id}
                                                                                   handleClose={this.loadShifts}/>
                                                              <ChangeShift id={shift.id} handleClose={this.loadShifts}/>
                                                          </div>
                                                        ) : null}
                                                    </Fragment>
                                                ) : null}
                                                {shift.shift.location.name}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="alert alert-danger">
                                    {t('supporterProject.notFound')}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default translate()(SupporterShiftsBlock);
